export default class UtilArray{

    static chunk(lista = [], chunks = 1){

        let chunkArray = [];
        while (lista.length) {
            chunkArray.push(lista.splice(0, chunks));
        }
        return chunkArray;

    }

    static isEmpty(array = []){
        return array.length == 0 ? true : false
    }

    static isNotEmpty(array = []){
        return array.length > 0 ? true : false
    }

    static unique(array=[]){
        return [...new Set(array)];
    }

    static getLast(array=[]){
        return array[array.length-1];
    }

    static clone = (array = []) => {

        return array.map(any => {return {...any}});

    }

}